import { noteHeadingClasses } from './noteText.styles';
import type { HeadingTextProps } from './noteText.types';

/** Note text with its section lines (e.g. "Ástæða komu:") in semibold. */
export const HeadingText = ({ pieces }: HeadingTextProps) =>
  pieces.map((piece, index) =>
    piece.heading ? (
      // biome-ignore lint/suspicious/noArrayIndexKey: pieces are positional and re-derived from the text
      <span key={index} className={noteHeadingClasses}>
        {piece.text}
      </span>
    ) : (
      piece.text
    )
  );
